var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSidebarHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "current",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1979 5.68275L12.3979 2.32442C11.0896 1.40775 9.08125 1.45775 7.82292 2.43275L3.64792 5.69109C2.81458 6.34109 2.15625 7.67442 2.15625 8.72442V14.4744C2.15625 16.5994 3.88125 18.3328 6.00625 18.3328H14.9896C17.1146 18.3328 18.8396 16.6078 18.8396 14.4828V8.83275C18.8396 7.70775 18.1146 6.32442 17.1979 5.68275ZM11.1229 14.9994C11.1229 15.3411 10.8396 15.6244 10.4979 15.6244C10.1563 15.6244 9.87292 15.3411 9.87292 14.9994V12.4994C9.87292 12.1578 10.1563 11.8744 10.4979 11.8744C10.8396 11.8744 11.1229 12.1578 11.1229 12.4994V14.9994Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarHome);
export default __webpack_public_path__ + "static/media/ic_sidebar_home.b2c2e04a79eabad0e9684a3901c899b6.svg";
export { ForwardRef as ReactComponent };